module.exports = __webpack_public_path__ + "img/TECNOLOGIA-IGNIS-2021-3.52e521ad.jpg";